import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'

async function fetchImpactCount(newTarget: number): Promise<number> {
  const { data, error } = await supabase.rpc('stamp_target_reduction_impact', {
    p_new_target: newTarget,
  })
  if (error) throw error
  return data ?? 0
}

export function useStampTargetImpact(newTarget: number | null) {
  return useQuery({
    queryKey: ['stamp-target-impact', newTarget],
    queryFn: () => fetchImpactCount(newTarget!),
    enabled: newTarget !== null,
  })
}